/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';
// tslint:disable-next-line: no-duplicate-imports
import { IActionContext } from '@msdyn365-commerce/core';
import { CacheType, QueryResultSettings, SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { getByIdsAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';

/**
 * GetProductById Input Action
 */

export class GetProductsByIdInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    public productIdsArr: number[];

    public channelId: number;
    public queryResultSettings: QueryResultSettings;
    constructor(productIdsArr: number[], channelId: number, queryResultSettings: QueryResultSettings) {
        this.productIdsArr = productIdsArr;
        this.channelId = channelId;
        this.queryResultSettings = queryResultSettings;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key

    public getCacheKey = () =>
        `Get-Products-By-Id-${this.productIdsArr && this.productIdsArr.length >= 1 ? this.productIdsArr.join('-') : ''}`;
    public getCacheObjectType = () => 'GetProductsById';
    public dataCacheType = (): CacheType => 'request';
}

// TODO: Create a data model here or import one to capture the response of the action

/**
 * TODO: Use this function to create the input required to make the action call
 */

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function getProductsByIdAction(input: GetProductsByIdInput, ctx: IActionContext): Promise<SimpleProduct[] | null> {
    if (input.productIdsArr && input.productIdsArr.length >= 1) {
        const ctxObject = { callerContext: ctx, queryResultSettings: input.queryResultSettings, bypass: 'none' };
        let result;
        try {
            result = await getByIdsAsync(ctxObject, input.channelId, input.productIdsArr);
            if (result) {
                return result;
            }
        } catch (error) {
            console.log('error', error);
        }
    }
    return null;
}
export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<SimpleProduct[] | null>>getProductsByIdAction,
    // TODO: Give your data action a unique id
    id: 'GetProductsById'
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
